<template>
  <v-draggable class="v-progress">
    <v-window :class="$style.wrapper" width="61.1rem">
      <div :class="$style.title">
        {{ title }}
      </div>
      <div :class="$style.progress"><div :style="{ transform: `scaleX(${ready / count})` }"></div></div>

      <div :class="$style.items">
        <check v-for="(task, index) in data.tasks" :key="index" :item="task" />
      </div>
    </v-window>
  </v-draggable>
</template>
<script>
import check from './check'

import plural from '@/utils/plural'

export default {
  name: 'v-progress',
  components: { check },
  props: {
    data: Object,
  },
  data: () => ({
  }),
  computed: {
    ready() {
      return this.data.tasks.filter(item => item.size === 'l' && item.ready).length
    },
    count() {
      return this.data.tasks.filter(item => item.size === 'l').length
    },
    title() {
      const { ready, count } = this
      return `${plural(ready, 'Выполнено', 'Выполнено', 'Выполнено')} ${ready} из ${count}`
    },
  },
}
</script>
<style lang="scss" module>
.wrapper {
  left: 15rem;
  top: 12.2rem;
  padding: 1.5rem 0;
}

.title {
  text-align: center;
}

.progress {
  width: 100%;
  height: 1rem;
  background: rgba(#09E56E, 0.2);
  border-radius: 0.3rem;
  margin-top: 1rem;
  margin-bottom: 2.3rem;

  & > div {
    background: #09E56E;
    width: 100%;
    height: 100%;
    border-radius: 0.3rem;
    transform-origin: left;
    transition: transform 0.3s ease;
  }
}
</style>
